import { render, staticRenderFns } from "./AddOrEditDocument.vue?vue&type=template&id=62852efd"
import script from "./AddOrEditDocument.vue?vue&type=script&lang=js"
export * from "./AddOrEditDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports